import React, { useEffect, useState } from "react";
import { Products, ErrorComp } from "./components/";
import { MenuItems } from "./types/types";

type Category = {
  catCode: string;
  catName: string;
  menuItems: MenuItems[];
};
function App() {
  const [items, setItems] = useState<Category[]>([]);
  const [error, setError] = useState(false);
  const [shopName, setShopName] = useState("");

  useEffect(() => {
    const getData = async () => {
      const res = await fetch("/Menu.json");
      if (!res.ok) {
        setError(true);
        return;
      }
      try {
        const data = await res.json();
        setShopName(data.menuGroup);
        setItems(data.serviceTimes[0].menuCategories);
      } catch (e) {
        setError(true);
        return;
      }
    };
    getData();
  }, []);

  if (error) return <ErrorComp />;

  return (
    <div className="App">
      <h1>{shopName}</h1>
      <div>
        {items?.map((item) => {
          return (
            <div>
              <h2 className="category-name">{item.catName}</h2>
              <div className="cards">
                {item.menuItems?.map((product: MenuItems) => (
                  <Products product={product} />
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default App;
